import { CurrencyPipe, NgClass } from '@angular/common';
import { Component, Input, OnDestroy } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { FuseCardComponent } from '@fuse/components/card';
import { NotificationClassEnum } from 'app/models/notification-class.enum';
import { Plan } from 'app/models/pricing.model';
import { LicenseType } from 'app/models/signup.model';
import { CVANotificationService } from 'app/services/cva-notification/cva-notification.service';
import { PaymentService } from 'app/services/payment/payment.service';
import { SignupService } from 'app/services/signup/signup.service';
import { SubscriptionService } from 'app/services/subscription/subscription.service';
import { ROUTE_CONSTANTS } from 'app/util/route.constants';
import { environment } from 'environments/environment';
import { Subject, takeUntil } from 'rxjs';
import { PlanSelectionDialogComponent } from './plan-selection-dialog/plan-selection-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'cva-standalone-subscription-pricing',
  standalone: true,

  imports: [
    PlanSelectionDialogComponent,
    MatButtonModule,
    FuseCardComponent,
    MatIconModule,
    CurrencyPipe,
    NgClass,
    RouterLink
  ],
  templateUrl: './subscription-pricing.component.html',
})
export class SubscriptionPricingComponent implements OnDestroy {
  @Input() isHeaderFooterRequired = true;
  @Input() isToUpgrade = false;
  @Input() plansListing: Plan[] = [];

  private readonly destroy$ = new Subject<void>();
  yearlyBilling = true;
  LicenseType = LicenseType;

  constructor(
    private readonly _router: Router,
    private readonly signupService: SignupService,
    private readonly route: ActivatedRoute,
    private readonly _paymentService: PaymentService,
    private readonly subscriptionService: SubscriptionService,
    private readonly cvaNotificationService: CVANotificationService,
    private readonly dialog: MatDialog
  ) {
    this.route.data.pipe(takeUntil(this.destroy$)).subscribe((data) => {
      if (data.initialData as Plan[]) {
        this.plansListing = data.initialData as Plan[];
      }
    });
  }

  get productName(): string {
    return environment.productBy;
  }

  get currentYear(): number {
    return new Date().getFullYear();
  }

  saveUser(planType: LicenseType, uno: number): void {
    if (!this.isToUpgrade) {
      this.signupService.updateSignupData({
        plan: planType,
        planIsYearly: this.yearlyBilling,
      });

      const signupData = this.signupService.getSignupData();

      const newSubscriptionObj = {
        uno,
        planType: planType,
        firstName: signupData.firstName,
        lastName: signupData.lastName,
        password: signupData.password,
        email: signupData.email
      };

      this.subscriptionService.saveUserSignupSubscription(newSubscriptionObj)
        .subscribe({
          next: (response) => {
            console.log(response)
            this.cvaNotificationService.showNotification(
              response.message,
              NotificationClassEnum.SUCCESS
            );
            this.signupService.resetSignupData();
            this._router.navigate([`${ROUTE_CONSTANTS.LOGIN}`])
          },
          error: (error) => {
            const message = this.handleError(error)
            this.cvaNotificationService.showNotification(
              message,
              NotificationClassEnum.ERROR
            );
          },
        });
    }
  }

  onGetStarted(plan: Plan) {
    const planName = plan.value;
    const dialogRef = this.dialog.open(PlanSelectionDialogComponent, {
      autoFocus: false,
      data: { planName },
      disableClose: true,
      panelClass: 'fuse-confirmation-dialog-panel',
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.saveUser(result.plan, result.users);
      }
    });
  }

  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  handleError(error: any): string {
    return (
      error?.error?.error?.errorMessage ||  // deeply nested
      error?.error?.errorMessage ||         // one level deep
      error?.errorMessage ||                // top level
      error?.message ||                     // fallback from JS error
      'Something went wrong. Please try again later.' // default
    );
  }


  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
